import { useQuery } from '@tanstack/react-query';
import { fetcher } from 'src/api/fetcher';
import { API_RESOURCES } from 'src/utils/constants';
import { getUuid } from 'src/utils/url';

export const usePrinter = (printerUri, options = {}) => {
  const { enabled = true, ...queryOptions } = options;
  return useQuery({
    queryKey: ['printer', 'printer-by-uri', printerUri],
    queryFn: () => fetcher(`${API_RESOURCES.PRINTER}/${getUuid(printerUri)}`),
    enabled: Boolean(enabled && printerUri),
    ...queryOptions,
  });
};

/**
 * Printer types by uri, for resolving a batch's `printer_type_relationships` - the
 * API carries the uris only, names live on the printer-type resource.
 */
export const usePrinterTypesByUris = (printerTypeUris, printerTypeKey = 'printer-types') => {
  return useQuery({
    queryKey: ['printer-types-by-uris', printerTypeKey, printerTypeUris],
    queryFn: () =>
      fetcher(API_RESOURCES.PRINTER_TYPE, {
        params: {
          'filter[uri]': printerTypeUris,
        },
      }),
    enabled: !!printerTypeUris && printerTypeUris.length > 0,
    select: data => data.resources,
  });
};

export const usePrinterType = (printerTypeUri, options = {}) => {
  const { enabled = true, ...queryOptions } = options;
  return useQuery({
    queryKey: ['printer-type', 'printer-type-by-uri', printerTypeUri],
    queryFn: () => fetcher(`${API_RESOURCES.PRINTER_TYPE}/${getUuid(printerTypeUri)}`),
    enabled: Boolean(enabled && printerTypeUri),
    ...queryOptions,
  });
};
